import { AlertType } from '../../enums/AlertType';
import { Alert } from '../../interfaces/Alert';
export const ALERT_HIGHLIGHTED_WARNING: Alert = {
  type: AlertType.Warning,
  title: {
    message: 'Warning',
    translate: false,
  },
  message: {
    message: 'alert.custom.highlighted_warning',
    translate: true,
  },
};
